import { render, staticRenderFns } from "./ViewPosting.vue?vue&type=template&id=6aca5560&scoped=true&"
import script from "./ViewPosting.vue?vue&type=script&lang=js&"
export * from "./ViewPosting.vue?vue&type=script&lang=js&"
import style0 from "./ViewPosting.vue?vue&type=style&index=0&id=6aca5560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca5560",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCheckbox,VCol,VImg,VRow,VSimpleTable})
